export const keys = {
    all: ["recipients"],

    referenceDatas: () => [
        ...keys.all,
        "referenceData"
    ],

    referenceData: (organizationID: number) => [
        ...keys.referenceDatas(),
        {
            organizationID
        }
    ],


    usageLists: () => [
        ...keys.all,
        "usages"
    ],

    usageList: (recipientID: number) => [
        ...keys.usageLists(),
        {
            recipientID
        }
    ],

   
};
